var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicrosoft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-1e1ef103-b022-4d50-b25b-4076a58e9c4e",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-c0766bd5-c34a-4719-9879-4244bc177128 {\n        fill: #f2f2f2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-c0766bd5-c34a-4719-9879-4244bc177128",
    d: "M15.23,15.23h-6.14v-6.14h6.14v6.14Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-c0766bd5-c34a-4719-9879-4244bc177128",
    d: "M22.91,15.23h-6.14v-6.14h6.14v6.14Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-c0766bd5-c34a-4719-9879-4244bc177128",
    d: "M22.91,22.91h-6.14v-6.14h6.14v6.14Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-c0766bd5-c34a-4719-9879-4244bc177128",
    d: "M15.23,22.91h-6.14v-6.14h6.14v6.14Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoft);
export default __webpack_public_path__ + "static/media/Microsoft.a4a1de965e4fbd792b162c3c0a82ee15.svg";
export { ForwardRef as ReactComponent };